<template>
	<el-dialog class="online-dialog" :close-on-click-modal="false" :title="'FTP编辑'" append-to-body :visible.sync="dialogVisible" width="660px">
		<div class="prepare" v-loading="loading">
            <el-form :model="ftpInfo" :rules="rules" ref="ftpForm" label-width="120px">
                <el-form-item label="FTP主机" prop="ftpIp">
                    <el-input v-model="ftpInfo.ftpIp" placeholder="请输入FTP主机" />
                </el-form-item>
                <el-form-item label="FTP端口" prop="ftpPort">
                    <el-input v-model="ftpInfo.ftpPort" placeholder="请输入FTP端口" />
                </el-form-item>
                <el-form-item label="FTP用户名" prop="ftpUserName">
                    <el-input v-model="ftpInfo.ftpUserName" placeholder="请输入FTP用户名" />
                </el-form-item>
                <el-form-item label="FTP密码" prop="ftpPassword">
                    <el-input v-model="ftpInfo.ftpPassword" placeholder="请输入FTP密码" />
                </el-form-item>
            </el-form>
			<div class="prepare-btn">
				<el-button @click="saveFn" type="warning" round>
					保存
				</el-button>
				<el-button @click="closeFn" round>
					取消
				</el-button>
			</div>
		</div>
	</el-dialog>
</template>

<script>
    import projectApi from '@/api/user.api'
    export default {
        name: 'SiteTypeDialog',
        data() {
            return {
                dialogVisible: false,
                loading: false,
                ftpId: '',
                ftpInfo: {},
            }
        },
        methods: {
            // 关闭弹框
            closeFn () {
                this.ftpId = ''
                this.dialogVisible = false
            },
            // 打开弹框
            showFn (ftpId) {
                this.ftpId = ftpId
                this.showFtpInfo()
                this.dialogVisible = true
            },
            // 获取FTP信息
            async showFtpInfo () {
                this.loading = true
                let { data } = await projectApi.getFtpInfo({ ftpId: this.ftpId })
                this.loading = false
                if (data.isSuccess) {
                    this.ftpInfo = data.data
                } else {
                    this.$message.error('获取ftp信息失败')
                }
            },
            // 保存FTP信息
            async saveFn () {
                // let { data } = await projectApi.updateFtpInfo({
                //     ftpId: this.ftpId,
                //     ...this.ftpInfo
                // })
                // if (data.isSuccess) {
                //     this.$message.success('保存成功')
                //     this.closeFn()
                // } else {
                //     this.$message.error('保存失败')
                // }
            },
        },
        watch: {},
        created() {
        },
        mounted() {
        },
        destroyed() {
        },
        computed: {
		},
    }
</script>

<style scoped lang="scss">
	.prepare {
		width: 100%;
		min-height: 175px;

		p {
			min-height: 52px;
		}

		.prepare-btn {
			padding: 40px 0;
			text-align: center;

			button {
				margin: 0 30px;
				position: relative;
			}
		}
	}
	.recommend{
		position: absolute; top: -9px; right: -1px; width: 34px; height: 18px; font-size: 12px; text-align: center; border-radius: 0 9px 0 9px; color: #fff; background: #f1592a; line-height: 18px;
	}
</style>
